import { useQuery } from 'react-query'
import { getJSON } from 'common/services/api'
import {
  STOCK_DASHBOARD_SUMMARY_QUERY_KEY,
  STOCK_DASHBOARD_SUMMARY_URL
} from './queryConstants'

type StockDashboardSummaryResponse = {
  lowStockCount: number
  outOfStockCount: number
  discontinuedRequiringDisposalCount: number
  openDiscrepanciesLast30DaysCount: number
}

type UseStockDashboardSummaryReturn = {
  data: StockDashboardSummaryResponse | null
  isLoading: boolean
  refetch: () => void
}

export const useStockDashboardSummary = (
  enabled: boolean = true
): UseStockDashboardSummaryReturn => {
  const { data, isLoading, refetch } = useQuery(
    [STOCK_DASHBOARD_SUMMARY_QUERY_KEY],
    () =>
      getJSON({
        url: STOCK_DASHBOARD_SUMMARY_URL
      }),
    {
      enabled,
      retry: 1
    }
  )

  return {
    data: (data as StockDashboardSummaryResponse) || null,
    isLoading,
    refetch
  }
}

export default useStockDashboardSummary

